import React from "react";
import { useOutlet, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../Hooks/AuthContext";
import { isEmpty } from "lodash";

/**
 * Gate for ProtectRoutes. A logged-out visitor is sent to login and brought BACK to the page
 * they asked for.
 *
 * Until now this did `<Navigate to="/" />`: it dropped them on the storefront home and forgot
 * where they were going. That was survivable while every protected route was reached from inside
 * the app, but order_rating_request now sends people a WhatsApp link straight to
 * /orders/:orderId. Landing on the shop home with no explanation is where most of them would stop.
 *
 * The return machinery already existed and was simply unused: AuthContext.login() ends with
 * `if (state?.from) navigate(state.from)`, and LoginMerged reads `state` from useLocation() and
 * passes it straight through. Setting state.from here is the only missing piece.
 *
 * `replace` keeps the protected URL out of history, so Back from the login screen does not bounce
 * the visitor through the gate again.
 */
const ProtectedLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();
  const location = useLocation();

  if (user === null || isEmpty(user)) {
    // pathname + search, so a query string on the target page survives the round trip.
    const from = `${location.pathname}${location.search || ""}`;
    return <Navigate to="/auth/login" state={{ from }} replace />;
  }

  return <React.Fragment>{outlet}</React.Fragment>;
};

export default ProtectedLayout;
